<template>
 <div class="relative flex flex-col items-center w-2/3 lg:w-full">
   <h1 class="w-full text-44px sm:text-32px xs:text-left font-bold text-neutral-50 mb-12">
     {{vacancy}}
   </h1>
   <h2 class="w-full text-32px sm:text-2xl font-bold text-left mb-12">
    {{ $t('video_interview.selection-stages') }}
   </h2>
   <ul class="w-full">
     <li class="flex items-center border-b py-6">
       <img src="@/assets/icons/ok-icon-transparent.svg" alt="">
       <span class="font-bold text-2xl sm:text-xl ml-12">
        {{ $t('video_interview.questionnaire') }}
       </span>
     </li>
     <li class="flex items-start py-6 w-full">
       <img src="@/assets/icons/videointerview.svg" alt="">
       <div class="flex flex-col ml-12 w-full md:pb-12">
         <span class="font-bold text-2xl sm:text-xl text-left">
          {{ $t('video_interview.video-interview') }}
         </span>
         <div class="interwiev-description  text-neutral-50 text-base sm:text-sm text-left mt-5" v-html="instruction">
         </div>
         <Button
           :disabled="cantContinue"
           class="md:absolute md:bottom-0 md:left-0 md:w-full mt-8 max-w-310px"
           @click="$emit('start')"
         >
           {{ $t('common.start') }}
         </Button>
       </div>
     </li>
   </ul>
 </div>
</template>
<script>
import Button from '@/components/UI/Button.vue';

export default {
  name: 'VacancyData',
  props: {
    vacancy: {
      type: [Object, Array],
      default: () => ([]),
    },
    cantContinue: {
      type: Boolean,
      default: false,
    },
    instruction: {
      type: String,
      default: '',
    },
  },
  components: {
    Button,
  },
};
</script>
<style lang="scss">
.interwiev-description {
  & ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  & ol {
    list-style-type: decimal;
  }

  & a {
    text-decoration: underline;
    color: #225CA4;
  }
}
</style>
